import React from 'react'
import classnames from 'classnames'
import { times, uniqueId } from 'lodash'

import styles from './LineScale.module.scss'

const BAR_COUNT = 5 // Keep in sync with scss until we have json wired in

// Ahead of time for slight render performance
const BARS = times(BAR_COUNT, i => <div key={uniqueId('lineScale')} />)

const LineScaleLoader = ({ className }) => (
  <div className={classnames(styles.lineScale, className)}>{BARS}</div>
)

export default LineScaleLoader
